import { render, staticRenderFns } from "./NotificationDropdown.vue?vue&type=template&id=173bd240"
import script from "./NotificationDropdown.vue?vue&type=script&lang=js"
export * from "./NotificationDropdown.vue?vue&type=script&lang=js"
import style0 from "./NotificationDropdown.vue?vue&type=style&index=0&id=173bd240&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports